import { Box, Paper, Typography } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { useState } from 'react';
import { OfferSummary } from '../../interfaces/Offer/OfferSummary';
import { useThemeColor } from '../../hooks/useThemeColor';
import { sharedColors } from '../../utils/Style';
import { OffersDialog } from '../../components/Offer/OffersDialog';
import { useLocalizedText } from '../../hooks/useLocalizedText';

type OffersCardProps = {
  offers: OfferSummary[];
};

export const OffersCard = ({ offers }: OffersCardProps) => {
  const t = useLocalizedText();

  const { primary } = useThemeColor();

  const [showDialog, setShowDialog] = useState(false);

  if (!offers.length) {
    return null;
  }

  return (
    <>
      <Paper
        onClick={() => setShowDialog(true)}
        elevation={3}
        sx={{
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'row',
          gap: 1.5,
          p: 1.5,
          boxSizing: 'border-box',
          minWidth: 300,
          width: '100%',
          maxWidth: 500,
        }}
      >
        <LocalOfferIcon sx={{ color: primary }} />

        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 600,
              color: sharedColors.gray6,
            }}
          >
            {offers.length > 1 ? t('product.product_offers') : offers[0].name}
          </Typography>

          <Typography
            sx={{
              fontSize: '14px',
              color: sharedColors.gray4,
              fontWeight: 400,
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              lineHeight: '1.2em',
              maxHeight: '2.4em',
              overflow: 'hidden',
            }}
          >
            {offers.length > 1
              ? t('product.n_offers_available', { n: offers.length })
              : offers[0].description}
          </Typography>
        </Box>
      </Paper>

      <OffersDialog
        offers={offers}
        open={showDialog}
        onClose={() => setShowDialog(false)}
      />
    </>
  );
};
